import React from 'react';
import { Select, Typography, useMultipleSelect } from '@vtblife/uikit';

import { SellType } from '@search/filter-enums/enums/SellType';

import { SellTypeFilter } from '../../../models/Filter';
import { MobileFilter2 } from '../../filter/MobileFilter2';
import { IFilterAvailableProps } from '../../new_filter/Filter2';

interface ISellTypeFilterProps extends IFilterAvailableProps {
    filter: SellTypeFilter;
    isRoom: boolean;
    handleChange: (filter: SellTypeFilter) => void;
    isMobile?: boolean;
    isSecond?: boolean;
}

const sellTypeOptions = [ {
    label: 'Прямая',
    value: SellType.SECONDARY
}, {
    label: 'Альтернативная',
    value: SellType.ALTERNATIVE
}, {
    label: 'Переуступка',
    value: SellType.PRIMARY_REASSIGNMENT
} ];

export const SellTypeSelectFilterView: React.FC<ISellTypeFilterProps> = ({
    filter,
    handleChange,
    isRoom,
    isMobile,
    withoutTitle,
    isSecond
}) => {
    const onChange = React.useCallback(val => {
        if (val === null) {
            return;
        }

        if (Array.isArray(val)) {
            handleChange(new SellTypeFilter(val));
        }
    }, [ handleChange ]);

    const sellTypeEnumeration = sellTypeOptions.filter(({ value }) => isRoom ? value !== SellType.PRIMARY_REASSIGNMENT : true);

    const sellTypeSelect = useMultipleSelect(
        onChange,
        {
            selected: filter.sellType,
            texts: sellTypeEnumeration.map(option => ({ value: option.value, text: option.label }))
        }
    );

    return (
        <MobileFilter2 filterTitle={withoutTitle ? undefined : (isSecond ? 'Параметры сделки' : 'Тип сделки')}>
            <Select native={isMobile} mode='multiple' onChange={sellTypeSelect.handleChange}>
                <Select.Button size='s' dataTest='sellType-trigger'>
                    {filter.sellType.length > 0 ? sellTypeSelect.selectedText : <Typography color='black-300'>Неважно</Typography>}
                </Select.Button>
                <Select.Content>
                    {sellTypeEnumeration.map(option => (
                        <Select.Option
                            dataTest={`sellType-${option.value}`}
                            key={option.value}
                            value={option.value}
                            selected={sellTypeSelect.is(option.value)}
                        >
                            {option.label}
                        </Select.Option>
                    ))}
                </Select.Content>
            </Select>
        </MobileFilter2>
    );
};
